module.exports = __webpack_public_path__ + "static/img/jigou-zhuhai-bottom.c512079.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jigou/jigou-zhuhai-bottom.png
// module id = b65c
// module chunks = 2